import React, { useState } from 'react';
import './committee-member-selector.css';
import { IconButton } from '../../../../components/icon-button';
import { CommitteeIcon } from '../../../../components/committee-icon';
import { Paragraph } from '../../../../components/paragraph';

const CommitteeMemberSelector = props => {
    const { committeeMembers, possibleMembers, toggleCommitteeMember } = props;

    const [activeMember, setActiveMember] = useState(1);

    const showPreviousCommitteeMember = () => {
        if (activeMember === 0) {
            setActiveMember(10);
        } else {
            setActiveMember(activeMember - 1);
        }
    };

    const showNextCommitteeMember = () => {
        if (activeMember === 10) {
            setActiveMember(0);
        } else {
            setActiveMember(activeMember + 1);
        }
    };

    const activeMemberIsOnCommittee = committeeMembers.includes(activeMember);

    return (
        <div className="committee-member-selector">
            <div className="committee-member-selector__member-identifiers">
                <Paragraph
                    withSpacing={false}
                    fontWeight="bold"
                    colorScheme="dark"
                    textAlign="center"
                >
                    {possibleMembers[activeMember].name}
                </Paragraph>
                <Paragraph
                    withSpacing={false}
                    fontWeight="bold"
                    colorScheme="dark"
                    textAlign="center"
                >
                    {possibleMembers[activeMember].occupation}
                </Paragraph>
            </div>
            <div className="committee-member-selector__selector">
                <IconButton
                    iconName="previous"
                    onClick={() => showPreviousCommitteeMember()}
                    size="small"
                />
                <CommitteeIcon
                    id={possibleMembers[activeMember].id}
                    index={activeMember}
                />
                <IconButton
                    onClick={() => showNextCommitteeMember()}
                    iconName="next"
                    size="small"
                />
            </div>
            <IconButton
                key={activeMemberIsOnCommittee}
                onClick={() => toggleCommitteeMember(activeMember)}
                iconName={activeMemberIsOnCommittee ? 'cross' : 'tick'}
                size="small"
                isDisabled={
                    !activeMemberIsOnCommittee && committeeMembers.length === 6
                }
                altText={
                    activeMemberIsOnCommittee
                        ? 'de-select member'
                        : 'select member'
                }
            />
            <div className="committee-member-selector__member-description">
                <Paragraph
                    withSpacing={false}
                    colorScheme="dark"
                    fontSize="small"
                    verticalAlign="top"
                    textAlign="center"
                >
                    {possibleMembers[activeMember].background}
                </Paragraph>
            </div>
        </div>
    );
};

export { CommitteeMemberSelector };
